import { render, staticRenderFns } from "./WordsByLength.vue?vue&type=template&id=6b3a74a0&scoped=true&"
import script from "./WordsByLength.vue?vue&type=script&lang=js&"
export * from "./WordsByLength.vue?vue&type=script&lang=js&"
import style0 from "./WordsByLength.vue?vue&type=style&index=0&id=6b3a74a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a74a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WordsByLengthFinder: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/finder/WordsByLengthFinder/WordsByLengthFinder.vue').default,InstructionCardsList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/InstructionCardsList/InstructionCardsList.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,RelatedLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/RelatedLinks/RelatedLinks.vue').default,TheArticlesPromo: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheArticlesPromo/TheArticlesPromo.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default,WordListInterlinkDirector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordListInterlinkDirector/WordListInterlinkDirector.vue').default})
